import consolv from 'lib/consolv';

const defaults = {
  creativeMetaRetriever: {
    enabled: false,
    endpoint: 'https://bmxocid8k6.execute-api.us-east-1.amazonaws.com/v1/{lineItemId}/',
  },
};

/**
 * Fetches additional creative meta data from an external API
 * @access private
 */
export function fetchCreativeMeta(MCP, { slot }) {
  const { endpoint } = MCP.Configurator.getConfiguration({ defaults }).creativeMetaRetriever;

  slot.setMetaData('creativeMetaLoaded', false);
  const { lineItemId } = slot.creative;

  // If there is no lineItemId, it is probably Google AdX, so we won't have any meta for it
  if (!endpoint || !lineItemId) {
    slot.setMetaData('creativeMetaLoaded', true);
    MCP._updateSlotMeta(slot);
    MCP.dispatchEvent('createiveMetaRetrieved', { slot });
    return Promise.resolve();
  }

  const configurationUrl = endpoint.replace('{lineItemId}', lineItemId);

  return fetch(configurationUrl)
    .then((response) => {
      if (response.status !== 200) throw new Error(response.status);
      return response.json();
    })
    .then((responseJSON) => {
      const creativeMeta = responseJSON.find(item => Number(item.id) === Number(lineItemId));
      if (creativeMeta) {
        if (creativeMeta.priority) slot.setMetaData('priority', Number(creativeMeta.priority));
        if (creativeMeta.kronosLocked) {
          // Value coming from API is either string of 1 or 0 (or nothing)
          slot.setMetaData('kronosLocked', creativeMeta.kronosLocked === '1');
        }
        if (creativeMeta.enableStickyMobile) {
          slot.setMetaData('enableStickyMobile', creativeMeta.enableStickyMobile === '1');
        }

        if (creativeMeta.disableStickyDesktop) {
          slot.setMetaData('disableStickyDesktop', creativeMeta.disableStickyDesktop === '1');
        }

        if (creativeMeta.lineItemName) {
          const sourceRegex = /(^APS Display \(Open Auction\))|(^APS)|^(prebid_[a-z0-9-]+)/;
          const source = sourceRegex.exec(creativeMeta.lineItemName);
          if (source[0]) {
            slot.setMetaData('creativeSource', source[0]);
          }
        }
      }
      slot.setMetaData('creativeMetaLoaded', true);
    })
    .catch((_) => {
      consolv.log('MCP: Unable to fetch creative meta data');
      slot.setMetaData('creativeMetaError', true);
    })
    .finally(() => {
      MCP._updateSlotMeta(slot);
      MCP.dispatchEvent('creativeMetaRetrieved', { slot });
    });
}

/**
 * @param {MCPInstance} MCP
 */
export default function CreativeMetaRetriever(MCP) {
  MCP.loaded.then(() => {
    const configuration =
      MCP.Configurator.getConfiguration({ defaults }).creativeMetaRetriever;

    if (configuration.enabled) {
      consolv.log('MCP: creativeMetaRetriever enabled');

      MCP.addEventListener('slotCreativeLoaded', (e) => {
        fetchCreativeMeta(MCP, e).then(() => {
          // Refresh slot configuration after creative meta has been loaded
          // MCP._updateSlotMeta(e.slot);
        });
      });
    }
  });
}
